export enum eUserSubscription {
  CLIENT_HOSTED = 'Client Hosted',
  BRONZE = 'Bronze',
  SILVER = 'Silver',
  GOLD = 'Gold',
  PLATINUM = 'Platinum',
  DIAMOND = 'Diamond'
}
